// extracted by mini-css-extract-plugin
export default {"block":"go","loading":"ho","spinner":"io","spin":"jo"};